import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      //
    }
  },
  computed: {
    loadStatusNepradeta() {
      return this.turLoadStatus === 0
    },
    loadStatusPaleista() {
      return this.turLoadStatus === 1
    },
    loadStatusGauta() {
      return this.turLoadStatus === 2
    },
    loadStatusNerasta() {
      return this.turLoadStatus === 3
    },
    loadStatusNutraukta() {
      return this.turLoadStatus === 4
    },
    loadStatusPasikeite() {
      return this.turLoadStatus === 5
    },
    loadStatusNesutampa() {
      return this.turLoadStatus === 6
    },
  },
  methods: {
    //
  },
}
